export enum ServerTypeEnum {
  UserVar = 'userVar',
}
